/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { AreaDto } from './areaDto.schema';

export const IReadOnlyListOfAreaDto = zod.array(zod.lazy(() => AreaDto));

export type IReadOnlyListOfAreaDto = zod.input<typeof IReadOnlyListOfAreaDto>;
export type IReadOnlyListOfAreaDtoOutput = zod.output<typeof IReadOnlyListOfAreaDto>;
